// Image path constants — all served from /public/imgs/
// Drop matching JPG files into /app/frontend/public/imgs/ to replace placeholders.

export const IMGS = {
  // Hero slider (full-width backgrounds)
  heroServo: "/imgs/hero-servo.png",
  heroIsolation: "/imgs/hero-isolation.png",
  heroApsc: "/imgs/hero-apsc.png",

  // Product tiles + detail pages
  servo: "/imgs/servo-stabilizer.png",
  isolation: "/imgs/isolation-three-phase.png",
  apsc: "/imgs/apsc.png",
  apc: "/imgs/phase-changer.jpg",
  timer: "/imgs/multi-purpose-timer.jpg",
  stabilizer: "/imgs/voltage-stabilizer.jpg",

  // About + factory gallery
  aboutHero: "/imgs/about-hero.jpg",
  factory1: "/imgs/factory-1.jpg",
  factory2: "/imgs/factory-2.jpg",
  factory3: "/imgs/factory-3.jpg",

  // Home CTA banner background
  ctaBanner: "/imgs/cta-banner.jpg",
};

export const PLACEHOLDER = "/imgs/placeholder.svg";

// Attach as onError to swap in the placeholder without breaking the layout.
export const onImgError = (e) => {
  if (e.currentTarget.src.endsWith("placeholder.svg")) return;
  e.currentTarget.src = PLACEHOLDER;
  e.currentTarget.onerror = null;
};
